import { Key } from '../engine/enums';
import { Renderable } from '../engine/renderable';
import Entity from '../entity';
import State from '../state';

import GameOverScreen from './gameOverScreen';
import GameScreen from './gameScreen';
import HighScoreScreen from './highScoreScreen';
import IntroScreen from './introScreen';

export type RenderableScreen = Omit<Renderable<State>, 'render'> & {
  initScreen(state: State): void;
  render(state: State, gameTime: number, ctx: CanvasRenderingContext2D): void;

  onPlayerInput(player: Entity, key: Key, state: State): void;
};

export enum Screen {
  Intro,
  Game,
  GameOver,
  HighScore,
}

export class ScreenManager {
  readonly width: number;
  readonly height: number;

  private readonly state: State;

  private introScreen: IntroScreen;
  private gameScreen: GameScreen;
  private gameOverScreen: GameOverScreen;
  private highScoreScreen: HighScoreScreen;

  private currentScreen: Screen = Screen.Intro;

  constructor(state: State, width: number, height: number) {
    this.state = state;
    this.width = width;
    this.height = height;

    this.introScreen = new IntroScreen(this);
    this.gameScreen = new GameScreen(this);
    this.gameOverScreen = new GameOverScreen(this);
    this.highScoreScreen = new HighScoreScreen(this);

    this.onChangeScreen();
  }

  onChangeScreen() {
    this.getCurrentScreen().initScreen(this.state);
  }

  getCurrentScreen(): RenderableScreen {
    switch (this.currentScreen) {
      case Screen.Intro:
        return this.introScreen;
      case Screen.Game:
        return this.gameScreen;
      case Screen.HighScore:
        return this.highScoreScreen;
      case Screen.GameOver:
      default:
        return this.gameOverScreen;
    }
  }

  setScreen(screen: Screen) {
    this.currentScreen = screen;
    this.onChangeScreen();
  }
}
